// Catalogue fixe des documents de conformité d'une opération (PM Spec 06/2026)
import { FileText, Shield, Wrench, IdCard, CreditCard, Truck, PackageCheck, Camera, Image, FilePlus } from 'lucide-react';

export const DOC_SECTIONS = [
  {
    key: 'A',
    title: 'A. Documents obligatoires avant départ',
    icon: FileText,
    color: 'text-emerald-600',
    docs: [
      { type: 'carte_grise', label: 'Carte grise', required: true, icon: FileText },
      { type: 'assurance_camion', label: 'Assurance', required: true, icon: Shield },
      { type: 'visite_technique', label: 'Visite technique', required: true, icon: Wrench },
      { type: 'cni_chauffeur', label: 'CNI chauffeur', required: true, icon: IdCard },
      { type: 'permis_conduire', label: 'Permis de conduire', required: true, icon: CreditCard },
    ],
  },
  {
    key: 'B',
    title: 'B. Documents opérationnels obligatoires',
    icon: Truck,
    color: 'text-emerald-600',
    docs: [
      { type: 'bon_chargement', label: 'Bon de chargement', required: true, icon: Truck },
      { type: 'bon_livraison', label: 'Bon de déchargement / livraison', required: true, icon: PackageCheck },
      { type: 'photos_depart', label: 'Photos avant départ', required: true, icon: Camera },
      { type: 'photos_chargement', label: 'Photos du chargement', required: true, icon: Camera },
      { type: 'photos_livraison', label: 'Photos de la livraison', required: true, icon: Image },
    ],
  },
  {
    key: 'C',
    title: 'C. Documents complémentaires',
    icon: FilePlus,
    color: 'text-teal-600',
    docs: [
      { type: 'autre', label: 'Autre document', required: false, icon: FilePlus },
    ],
  },
];

// Source lisible d'un document
export const sourceLabel = (doc) => {
  if (!doc) return '—';
  const role = doc.uploadedByRole;
  if (['field_ops', 'lead_field_ops'].includes(role)) return 'Terrain';
  if (role === 'client') return 'Client';
  if (['admin', 'ops', 'lead_ops', 'operateur'].includes(role)) return 'Bureau';
  if (role) return 'Baobab';
  return '—';
};

// Statut UX d'un type de document à partir des documents uploadés
export const docStatus = (docsOfType) => {
  if (!docsOfType || docsOfType.length === 0) return 'manquant';
  const latest = docsOfType[0];
  if (latest.status === 'validated') return 'valide';
  if (latest.status === 'rejected') return 'refuse';
  return 'a_verifier'; // reçu mais pas encore validé
};

export const STATUS_CONFIG = {
  manquant: { label: 'Manquant', cls: 'bg-red-50 text-red-600 border-red-200' },
  recu: { label: 'Reçu', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  a_verifier: { label: 'À vérifier', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  valide: { label: 'Validé', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  refuse: { label: 'Refusé', cls: 'bg-red-50 text-red-700 border-red-300' },
  expire: { label: 'Expiré', cls: 'bg-red-50 text-red-700 border-red-300' },
};

export const fmtDate = (d) => {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
  catch { return '—'; }
};
